import { Fade } from '@progress/kendo-react-animation';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { removeMessage } from 'redux/actions/global';
import React, { Component } from 'react';
import { connect } from 'react-redux';
// @ts-ignore
import styles from './overlay.module.scss';

interface MessagesComponentProps {
  messages : any,
  removeMessage : any
}

class MessagesComponent extends Component<MessagesComponentProps> {
  componentDidMount() {
    if (this.props.messages && this.props.messages.length > 0) {
      this.props.messages.forEach((item) => {
        this.props.removeMessage(item.id);
      });
    }
  }

  render() {
    const remove = this.props.removeMessage;
    return (
      <div className={styles.messagesContainer}>
        { /* @ts-ignore */ }
        <NotificationGroup className={styles.topCenter}>
          {this.props.messages.length > 0
                        && this.props.messages.map((message) => (
                          <Fade key={message.id} enter exit>
                            { /* @ts-ignore */ }
                            <Notification
                              type={{ style: message.type, icon: true }}
                              closable
                              onClose={() => remove(message.id)}
                            >
                              <span>{message.text}</span>
                            </Notification>
                          </Fade>
                        ))}
        </NotificationGroup>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    messages: state.global.messages,
  };
}

const mapDispatchToProps = {
  removeMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagesComponent);
